function DisabledPlanIcon() {
  return (
    <svg fill="none" height="54" viewBox="0 0 54 54" width="54" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M 53 27 C 53 41.4 41.4 53 27 53 C 12.6 53 1 41.4 1 27 C 1 12.6 12.6 1 27 1 C 41.4 1 53 12.6 53 27 Z"
        fill="white"
        stroke="#dedede"
        strokeWidth="2"
      />
      <path
        clipRule="evenodd"
        d="M 17 34 C 15.3 34 14 32.7 14 31 V 20 C 14 18.3 15.3 17 17 17 H 34 C 35.7 17 37 18.3 37 20 V 31 C 37 32.7 35.7 34 34 34 H 17 Z"
        fill="white"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M 34 16 H 17 C 14.8 16 13 17.8 13 20 V 31 C 13 33.2 14.8 35 17 35 H 34 C 36.2 35 38 33.2 38 31 V 20 C 38 17.8 36.2 16 34 16 Z M 34 18 C 35.1 18 36 18.9 36 20 V 31 C 36 32.1 35.1 33 34 33 H 17 C 15.9 33 15 32.1 15 31 V 20 C 15 18.9 15.9 18 17 18 H 34 Z"
        fill="#dedede"
        fillRule="evenodd"
      />
      <path
        d="M 37 22 H 14"
        stroke="#dedede"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        clipRule="evenodd"
        d="M 43.7 32.7 C 43.7 36.8 40.4 40.2 36.2 40.2 C 32.1 40.2 28.7 36.8 28.7 32.7 C 28.7 28.5 32.1 25.2 36.2 25.2 C 40.4 25.2 43.7 28.5 43.7 32.7 Z"
        fill="#dedede"
        fillRule="evenodd"
      />
      <path
        d="M 33.6 35.3 L 38.9 30"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}

export default DisabledPlanIcon;
